/* kokoot 自定义品牌变体下拉 <kk-dropdown> (2号小哥 2026-06-17)
   全站加载. 渐进增强: 未定义时(本脚本未跑)CSS :not(:defined) 让原生 <select> 可见、自定义UI隐藏;
   定义后 CSS :defined 隐藏 select 显示自定义UI. 交互逻辑只负责选中同步:
   移动 <option> 的 selected 属性 + 设 selectedIndex + 派发冒泡 change, 让主题 variant-picker.js 接管.
   事件委托挂在 <kk-dropdown> 根元素(变体切换 morph 后该根被原地保留, 监听仍有效);
   元素若被 morph 重新插入, connectedCallback 会重跑并因 _wired 守卫安全跳过重复绑定. */
(function () {
  if (!window.customElements || customElements.get('kk-dropdown')) return;

  customElements.define('kk-dropdown', class extends HTMLElement {
    connectedCallback() {
      if (this._wired) return;
      this._wired = true;
      this._active = -1;

      this.addEventListener('click', (e) => {
        if (e.target.closest('.kkdrop__trigger')) { e.preventDefault(); this.toggle(); return; }
        const li = e.target.closest('.kkdrop__opt');
        if (li) this.choose(li);
      });
      this.addEventListener('keydown', (e) => this.onKey(e));
      this.addEventListener('focusout', (e) => {
        if (!this.contains(e.relatedTarget)) this.close();
      });
      this._outside = (e) => { if (!this.contains(e.target)) this.close(); };
    }

    get trigger() { return this.querySelector('.kkdrop__trigger'); }
    get panel() { return this.querySelector('.kkdrop__panel'); }
    get select() { return this.querySelector('.kkdrop__select'); }
    get current() { return this.querySelector('.kkdrop__current'); }
    opts() { return Array.prototype.slice.call(this.querySelectorAll('.kkdrop__opt')); }
    selectedIndex() {
      const o = this.opts();
      for (let i = 0; i < o.length; i++) if (o[i].classList.contains('is-selected')) return i;
      return 0;
    }

    toggle() { this.classList.contains('is-open') ? this.close() : this.open(); }

    open() {
      const panel = this.panel, trigger = this.trigger;
      if (!panel || !trigger) return;
      if (this.classList.contains('is-open')) { panel.focus(); return; }
      panel.hidden = false;
      this.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
      panel.focus();
      this.setActive(this.selectedIndex());
      setTimeout(() => document.addEventListener('click', this._outside, true), 0);
    }

    close() {
      if (!this.classList.contains('is-open')) {
        document.removeEventListener('click', this._outside, true);
        return;
      }
      const panel = this.panel, trigger = this.trigger;
      if (panel) panel.hidden = true;
      this.classList.remove('is-open');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      this.setActive(-1);
      document.removeEventListener('click', this._outside, true);
    }

    setActive(i) {
      const o = this.opts(), panel = this.panel;
      o.forEach((el) => el.classList.remove('is-active'));
      this._active = i;
      if (i >= 0 && o[i]) {
        o[i].classList.add('is-active');
        if (panel && o[i].id) panel.setAttribute('aria-activedescendant', o[i].id);
        if (o[i].scrollIntoView) o[i].scrollIntoView({ block: 'nearest' });
      } else if (panel) {
        panel.removeAttribute('aria-activedescendant');
      }
    }

    onKey(e) {
      const o = this.opts(), n = o.length;
      if (!n) return;
      const open = this.classList.contains('is-open');
      if (!open) {
        if (e.key === 'ArrowDown' || e.key === 'ArrowUp' || e.key === 'Enter' || e.key === ' ') {
          if (e.target.closest('.kkdrop__trigger')) { e.preventDefault(); this.open(); }
        }
        return;
      }
      if (e.key === 'ArrowDown') { e.preventDefault(); this.setActive((this._active + 1) % n); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); this.setActive((this._active - 1 + n) % n); }
      else if (e.key === 'Home') { e.preventDefault(); this.setActive(0); }
      else if (e.key === 'End') { e.preventDefault(); this.setActive(n - 1); }
      else if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); if (o[this._active]) this.choose(o[this._active]); }
      else if (e.key === 'Escape' || e.key === 'Esc') { e.preventDefault(); this.close(); const t = this.trigger; if (t) t.focus(); }
      else if (e.key === 'Tab') { this.close(); }
    }

    choose(li) {
      const select = this.select;
      if (!select || !li) return;
      const value = li.getAttribute('data-value');
      const options = select.options;
      let target = null;
      for (let k = 0; k < options.length; k++) { if (options[k].value === value) { target = options[k]; break; } }
      if (!target) return;
      for (let j = 0; j < options.length; j++) { options[j].removeAttribute('selected'); options[j].selected = false; }
      target.setAttribute('selected', 'selected');
      target.selected = true;
      select.selectedIndex = target.index;
      const label = li.querySelector('.kkdrop__opt-label');
      const cur = this.current;
      if (cur) cur.textContent = label ? label.textContent.trim() : value;
      this.opts().forEach((el) => {
        const sel = el === li;
        el.classList.toggle('is-selected', sel);
        el.setAttribute('aria-selected', sel ? 'true' : 'false');
      });
      this.close();
      const t = this.trigger; if (t) t.focus();
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });
})();
